import { ChevronRight } from "lucide-react";
import { useRef } from "react";
import CompanyImage from "../../assets/images/final.png";

import logo from "../../assets/images/Logo.png";
import CloseIcon from "../../assets/icons/DELETE __ DARK.svg";
import ExportIcon from "../../assets/icons/exportYellow.svg";
import { toPng } from "html-to-image";
import { useNavigate, useSearchParams } from "react-router-dom";
import Winner from "../../assets/icons/winner.svg";
import { cn, getTeamPosition } from "../../utils/utils";
import ChartTeamBox from "./ChartTeamBox";
import ChartTeamMatchBox from "./ChartTeamMatchBox";
import ImageIcon from "../global/ImageIcon";
import LeaguesIcon from "../../assets/icons/LeaguesIcon";
import ShareIcon from "../../assets/icons/ShareIcon";
import { toast } from "react-toastify";
import useClipBoard from "../../hooks/useClipBoard";

type Props = {
  groupedMatches: { [key: string]: any };
  generalINfo: any;
  isShareMode: boolean;
  type: "leagues" | "tournaments";
};

function SimiFinal({ groupedMatches, type, generalINfo, isShareMode }: Props) {
  console.log(groupedMatches);
  const finalMatch = groupedMatches?.Final.find(
    (item: any) => item.final_type === "winner"
  );
  const thirdPlaceMatch = groupedMatches?.["3rd Place"].find(
    (item: any) => item.final_type === "loser"
  );

  console.log(finalMatch);
  const [searchParams] = useSearchParams();

  const elementRef = useRef(null);
  const navigate = useNavigate();
  const htmlToImageConvert = () => {
    //@ts-ignore
    toPng(elementRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "trophy.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const { copyText } = useClipBoard();
  return (
    <div className="w-full h-dvh flex flex-col  bg-white">
      {!isShareMode && (
        <div className="header py-2 px-2 bg-primary text-white flex gap-4 items-center justify-between">
          <div className=" flex gap-4 items-center flex-1">
            <ImageIcon Icon={LeaguesIcon} width={40} height={40} />
            <div className="flex gap-2 items-center">
              <span
                className="font-bold text-lg cursor-pointer"
                onClick={() => navigate("/competitive/" + type)}
              >
                {type}
              </span>{" "}
              <ChevronRight size={15} />{" "}
              <span className="font-bold text-lg">Final</span>
            </div>
          </div>
          <div className="logo flex justify-center flex-[3]">
            <img loading="lazy" src={logo} alt="" />
          </div>
          <div className="close flex-1 flex justify-end">
            <img
              loading="lazy"
              src={CloseIcon}
              alt=""
              width={28}
              height={28}
              className="cursor-pointer"
              onClick={() => navigate("/competitive/" + type)}
            />
          </div>
        </div>
      )}
      <div className="relative w-full h-full">
        {groupedMatches && (
          <div className="flex justify-between absolute z-50 p-6 items-center w-full ">
            <div className="club flex items-center gap-2 flex-1">
              <img
                loading="lazy"
                src={generalINfo.club_id.logo}
                alt=""
                width={100}
                height={100}
                className="rounded-full w-[80px] h-[80px] object-cover"
              />
              <span className="text-lg text-primary dark:text-white font-bold">
                {generalINfo.club_id.name}
              </span>
            </div>
            <div className="p-2 px-4  bg-white rounded-l-full rounded-r-full min-w-[200px] flex flex-col border border-primary flex-1 max-w-[200px]">
              <div className="flex gap-4 pr-10">
                {generalINfo?.poster_url && (
                  <img
                    loading="lazy"
                    src={generalINfo?.poster_url}
                    alt=""
                    className="rounded-full w-[60px] h-[60px] object-cover bg-red-100"
                  />
                )}
                <div
                  className={cn(
                    "flex  gap-2",
                    generalINfo?.poster_url && "flex-col"
                  )}
                >
                  <h3>{searchParams.get("name")}</h3>
                  <p>{generalINfo?.tournament_type}</p>
                </div>
              </div>
            </div>
            <div className="sponsors flex items-center gap-2 flex-1 justify-end">
              {generalINfo.sponsor_ids.map((item: any) => {
                if (item.logo_url) {
                  return (
                    <img
                      loading="lazy"
                      src={item.logo_url}
                      alt=""
                      width={40}
                      height={40}
                      className="rounded-full w-[80px] h-[80px] object-cover border border-primary"
                    />
                  );
                } else return null;
              })}
            </div>
          </div>
        )}
        {groupedMatches && (
          <div
            ref={elementRef}
            className="relative w-full h-full grid grid-cols-6 grid-rows-1  bg-white place-content-start"
          >
            <img
              loading="lazy"
              src={CompanyImage}
              alt=""
              className="absolute w-full h-full object-contain "
            />
            <div className=" col-span-2  flex flex-col justify-around items-start gap-2 rounded-lg font-bold text-lg text-primary dark:text-white">
              {groupedMatches["Semi Final"] &&
                new Array(1).fill(0).map((item, index: number) => {
                  return (
                    <div className="h-[30vh] pl-5 w-full rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative ">
                      <div className="h-[20vh] pl-5 w-[70%] rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative flex-col gap-4">
                        <ChartTeamBox
                          data={groupedMatches["Semi Final"][index]}
                          type="Quarter"
                          isGuest={false}
                        />
                        <ChartTeamBox
                          data={groupedMatches["Semi Final"][index]}
                          type="Quarter"
                          isGuest={true}
                        />
                      </div>
                      <div className="h-[12vh] border border-secondary w-[30%] border-l-0 rounded-md rounded-l-none relative text-sm">
                        {groupedMatches["Semi Final"] &&
                          groupedMatches["Semi Final"][index].winner && (
                            <ul className="absolute flex items-center -top-7 left-4 text-[#747474] font-digital gap-1 text-lg">
                              <li>
                                {
                                  groupedMatches["Semi Final"][index]
                                    .team_line_ids[0]?.score_1
                                }{" "}
                              </li>
                              {parseInt(
                                groupedMatches["Semi Final"][index]
                                  .set_per_match
                              ) !== 1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Semi Final"][index]
                                        .team_line_ids[0]?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Semi Final"][index]
                                        .team_line_ids[0]?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {groupedMatches["Semi Final"][index].winner?.id &&
                                groupedMatches["Semi Final"][index].winner
                                  ?.id ===
                                  groupedMatches["Semi Final"][index]
                                    .team_line_ids[0]?.team_id?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                        {groupedMatches["Semi Final"] &&
                          groupedMatches["Semi Final"][index].winner && (
                            <ul className="absolute flex items-center bottom-0 left-4 text-[#747474]  font-digital gap-1 text-lg">
                              <li>
                                {
                                  groupedMatches["Semi Final"][index]
                                    .team_line_ids[1]?.score_1
                                }{" "}
                              </li>
                              {parseInt(
                                groupedMatches["Semi Final"][index]
                                  .set_per_match
                              ) !== 1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Semi Final"][index]
                                        .team_line_ids[1]?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Semi Final"][index]
                                        .team_line_ids[1]?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {groupedMatches["Semi Final"][index].winner?.id &&
                                groupedMatches["Semi Final"][index].winner
                                  ?.id ===
                                  groupedMatches["Semi Final"][index]
                                    .team_line_ids[1]?.team_id?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                      </div>
                      {/* <ChartTeamMatchBox data={groupedMatches["Semi Final"][index]} type='Quarter'  /> */}
                      {/* <div className='flex-1 bg-[#1E18501A] h-full flex justify-center items-center'>{groupedMatches["Semi Final"][index].teams.split('X')[0]}</div>
          <span className='absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]'>{groupedMatches["Semi Final"][index].match_code}</span>
          <div className='flex-1 bg-[#EF46261A] h-full flex justify-center items-center'>{groupedMatches["Semi Final"][index].teams.split('X')[1]}</div> */}
                    </div>
                  );
                })}
            </div>
            <div className=" col-span-2  flex flex-col justify-around items-start gap-1 rounded-lg font-bold text-lg text-primary dark:text-white relative">
              <div className="h-[20vh] w-full pr-4 rounded-lg  text-center flex items-center relative">
                <div className="h-full w-[80%] mx-auto z-20  ">
                  <div className="h-full z-20">
                    <ChartTeamMatchBox
                      data={finalMatch}
                      type="Semi"
                      getTeamPosition={getTeamPosition}
                      SemiFinalData={groupedMatches["Semi Final"]}
                      isWinner={true}
                    />
                  </div>
                  <div className="mt-[10vh] h-full w-[80%] mx-auto relative">
                    <ChartTeamMatchBox
                      data={thirdPlaceMatch}
                      getTeamPosition={getTeamPosition}
                      SemiFinalData={groupedMatches["Semi Final"]}
                      type="Semi"
                      isWinner={false}
                      placeType="third place"
                    />
                    <div className="absolute -left-[20%] bottom-[50%] w-[140%] h-[calc(100%+10vh)] border border-[#cccccc] z-10 border-t-0"></div>
                  </div>
                </div>

                {/* <div className='flex-1 bg-[#1E18501A] h-full flex justify-center items-center'>{groupedMatches["Semi Final"][2 +index].teams.split('X')[0]}</div>
            <span className='absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]'>{groupedMatches["Semi Final"][2 +index].match_code}</span>
            <div className='flex-1 bg-[#EF46261A] h-full flex justify-center items-center'>{groupedMatches["Semi Final"][2 +index].teams.split('X')[1]}</div> */}
                <div className="absolute top-[50%] w-[100%] h-[1px] border border-[#cccccc] z-10 "></div>
              </div>
            </div>
            {/* <div className='col-span-2 flex flex-col justify-center items-center w-full z-20 relative'>
         <div className='h-[20vh] pl-4 w-full rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative justify-around'></div>
        <div className='h-[20vh] font-bold text-lg  w-[80%] mx-auto  rounded-md flex justify-center items-center text-primary dark:text-white  z-20'>
          
          
         
        </div>
        <div className='absolute top-[50%] w-[100%] h-[1px] border border-[#cccccc] z-10 '></div>
       </div> */}

            <div className=" col-span-2  flex flex-col justify-around items-start gap-2 rounded-lg font-bold text-lg text-primary dark:text-white">
              {groupedMatches["Semi Final"] &&
                new Array(1).fill(0).map((item, index: number) => {
                  return (
                    <div className="h-[30vh]   w-full pr-5 rounded-lg  text-center flex items-center relative">
                      <div className="h-[12vh] border border-secondary w-[30%] border-r-0 rounded-md rounded-r-none relative text-sm">
                        {groupedMatches["Semi Final"] &&
                          groupedMatches["Semi Final"][1 + index].winner && (
                            <ul className="absolute flex text-[#747474] items-center -top-7 right-4  font-digital gap-1 text-lg">
                              {groupedMatches["Semi Final"][1 + index].winner
                                ?.id &&
                                groupedMatches["Semi Final"][1 + index].winner
                                  ?.id ===
                                  groupedMatches["Semi Final"][1 + index]
                                    .team_line_ids[0]?.team_id?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                              <li>
                                {
                                  groupedMatches["Semi Final"][1 + index]
                                    .team_line_ids[0]?.score_1
                                }{" "}
                              </li>
                              {parseInt(
                                groupedMatches["Semi Final"][1 + index]
                                  .set_per_match
                              ) !== 1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Semi Final"][1 + index]
                                        .team_line_ids[0]?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Semi Final"][1 + index]
                                        .team_line_ids[0]?.score_3
                                    }
                                  </li>
                                </>
                              )}
                            </ul>
                          )}
                        {groupedMatches["Semi Final"] &&
                          groupedMatches["Semi Final"][1 + index].winner && (
                            <ul className="absolute flex text-[#747474] items-center bottom-0 right-4  font-digital gap-1 text-lg">
                              {groupedMatches["Semi Final"][1 + index].winner
                                ?.id &&
                                groupedMatches["Semi Final"][1 + index].winner
                                  ?.id ===
                                  groupedMatches["Semi Final"][1 + index]
                                    .team_line_ids[1]?.team_id?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                              <li>
                                {
                                  groupedMatches["Semi Final"][1 + index]
                                    .team_line_ids[1]?.score_1
                                }{" "}
                              </li>
                              {parseInt(
                                groupedMatches["Semi Final"][1 + index]
                                  .set_per_match
                              ) !== 1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Semi Final"][1 + index]
                                        .team_line_ids[1]?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      groupedMatches["Semi Final"][1 + index]
                                        .team_line_ids[1]?.score_3
                                    }
                                  </li>
                                </>
                              )}
                            </ul>
                          )}
                      </div>
                      <div className="w-[70%] h-[20vh] flex-col gap-2  pr-5 rounded-lg  text-center flex items-center relative">
                        <ChartTeamBox
                          data={groupedMatches["Semi Final"][1 + index]}
                          type="Quarter"
                          isGuest={false}
                        />
                        <ChartTeamBox
                          data={groupedMatches["Semi Final"][1 + index]}
                          type="Quarter"
                          isGuest={true}
                        />
                      </div>

                      {/* <ChartTeamMatchBox data={groupedMatches["Semi Final"][2 +index]}  type='Quarter'/> */}
                      {/* <div className='flex-1 bg-[#1E18501A] h-full flex justify-center items-center'>{groupedMatches["Semi Final"][2 +index].teams.split('X')[0]}</div>
          <span className='absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]'>{groupedMatches["Semi Final"][2 +index].match_code}</span>
          <div className='flex-1 bg-[#EF46261A] h-full flex justify-center items-center'>{groupedMatches["Semi Final"][2 +index].teams.split('X')[1]}</div> */}
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </div>

      <div className="flex justify-end items-center gap-4 pb-2 pr-4">
        {!isShareMode && (
          <button
            className="px-4 py-4 rounded-md text-primary dark:text-white border border-primary bg-[#F3F3F3] flex gap-2 items-center"
            onClick={() => {
              console.log(
                window.location.href.replace("/final", "/final/share")
              );
              copyText(
                window.location.href.replace("/final", "/final/share"),
                () => {
                  toast.success("link copied successfully");
                }
              );
            }}
          >
            <ImageIcon Icon={ShareIcon} width={28} height={28} /> share as image
          </button>
        )}
        <button
          className="px-4 py-4 bg-primary rounded-md text-primaryYellow dark:text-primaryYellow flex gap-2 items-center "
          onClick={htmlToImageConvert}
        >
          <img loading="lazy" src={ExportIcon} alt="" width={28} height={28} />
          download as image
        </button>
      </div>
    </div>
  );
}

export default SimiFinal;
/*
  <div ref={elementRef} className='relative w-full h-full grid grid-cols-12 grid-rows-1 px-12 bg-white'>
            <img loading="lazy" src={CompanyImage} alt="" className='absolute w-full h-full object-contain ' />
                <div className='w-full h-full col-span-1 py-4  grid grid-rows-2 grid-cols-1 gap-4 items-center justify-between z-40'>
                    <div className='w-full grid-rows-1 max-h-[20vh] h-full rounded-lg bg-[#F3F3F3] flex-1 relative border border-primary flex items-center justify-center text-primary dark:text-white font-bold'>
                        <h3 className="text-lg">{groupedMatches && groupedMatches['Semi Final'] && groupedMatches['Semi Final'].length > 0 ? groupedMatches['Semi Final'][0].teams.split("X")[0] : null}</h3>
                    </div>
                    <div className='w-full max-h-[20vh] grid-rows-1 h-full rounded-lg bg-[#F3F3F3] flex-1 border border-primary flex items-center text-primary dark:text-white font-bold justify-center'>
                    <h3 className="text-lg">{groupedMatches && groupedMatches['Semi Final'] && groupedMatches['Semi Final'].length > 0 ? groupedMatches['Semi Final'][0].teams.split("X")[1] : null}</h3>
                    </div>
                </div>
                <div className='w-full col-span-4 py-6  h-full grid grid-cols-1 grid-rows-1  items-center place-content-center place-items-center z-30'>
                
                <div className='w-full max-h-[18vh] flex items-center max-w-[12vw]  grid-rows-2 h-full  relative '>
                    <div className='w-full h-[80%] my-auto max-w-[12vw] rounded-lg bg-[#F3F3F3]     border border-primary flex flex-col items-center justify-center font-bold text-primary dark:text-white'>
                        <h3 className='text-lg flex flex-col justify-center items-center'>{groupedMatches && groupedMatches['Semi Final'] && groupedMatches['Semi Final'].length > 0 &&groupedMatches['Semi Final'][0].winner?.name ||<>
                        <span>{groupedMatches['Semi Final'][0].match_code}</span> <span>{groupedMatches['Semi Final'][0].teams}</span></> }</h3>
                      
                    </div>
                    {/* ,groupedMatches && groupedMatches['Semi Final'] && groupedMatches['Semi Final'].length > 0 &&groupedMatches['Semi Final'][0].winner?.name &&(groupedMatches['Semi Final'][0].winner?.name ===groupedMatches['Semi Final'][0].teams.split("X")[0] ? "split-border-up" : "split-border-down") }*/
/*
                    <div className={cn("absolute -top-[75%] -left-full w-[150%] h-[250%]  -z-10 rounded-lg border-2 border-[#cccccc] border-l-0 ")}></div>
                    </div>
                    </div>
                    <div className='w-full col-span-2 py-6  h-full grid grid-cols-1 grid-rows-1  items-center place-content-center place-items-center z-20 relative'>
                    <div className='w-full max-h-[15vh] max-w-[15vw] rounded-lg  grid-rows-1 h-full  bg-[#CBDB2A]  relative flex items-center justify-center font-bold text-primary dark:text-white z-10'>
                    <div className='w-full max-h-[15vh] max-w-[15vw] rounded-lg   h-full  bg-[#CBDB2A]  relative flex items-center justify-center font-bold text-primary dark:text-white '>
                            <h3 className='text-lg '>{groupedMatches?.Final && groupedMatches?.Final.length > 0 &&finalMatch.winner?.name || finalMatch.teams }</h3>
    
                           <div className={cn('absolute top-[50%] w-[350%] h-[1px] border border-[#cccccc] -z-10 ')}></div>
                        <img loading="lazy" src={VictoryIcon} width={40} height={40} alt="" className='absolute bottom-0 right-0' />
                    </div>
                    <div className='absolute top-0 left-[50%] w-[2px] h-[160%]  -z-10 rounded-lg border border-[#cccccc] border-l-0'></div>
                    <div className='absolute top-[160%] left-[15%] w-[70%] h-[80%]  -z-10 rounded-lg bg-primaryRed flex items-center justify-center font-bold text-white'>
                    <h3 className='text-lg '>{groupedMatches?.Final && groupedMatches?.Final.length > 0 &&thirdPlaceMatch?.winner?.name || thirdPlaceMatch?.teams }</h3>
                    </div>
                    </div>
                    
                    </div>
                   
                    <div className='w-full col-span-4 py-6  h-full grid grid-cols-1 grid-rows-1  items-center place-content-center place-items-center z-20'>
                    
                    <div className='w-full max-h-[18vh] flex items-center max-w-[12vw]  grid-rows-2 h-full  relative'>
                        <div className='w-full h-[80%] my-auto max-w-[12vw] rounded-lg bg-[#F3F3F3]     border border-primary flex items-center justify-center text-primary dark:text-white font-bold'>
                        <h3 className='text-lg flex flex-col justify-center items-center'>{groupedMatches && groupedMatches['Semi Final'] && groupedMatches['Semi Final'].length > 0 &&groupedMatches['Semi Final'][1].winner?.name ||<>
                            <span>{groupedMatches['Semi Final'][1].match_code}</span> <span>{groupedMatches['Semi Final'][1].teams}</span></> }</h3>
                        </div>
                        {/* ,groupedMatches && groupedMatches['Semi Final'] && groupedMatches['Semi Final'].length > 0 &&groupedMatches['Semi Final'][1].winner?.name &&(groupedMatches['Semi Final'][1].winner?.name.trim() ===groupedMatches['Semi Final'][1].teams.split("X")[0].trim() ? "split-border-up" : "split-border-down") }*/
/*
                    <div className={cn("absolute -top-[75%] -right-full w-[150%] h-[250%]  -z-10 rounded-lg border-2 border-[#CCCCCC] border-r-0  ")}></div>
                    </div>
                    </div>
                    <div className='w-full h-full col-span-1 py-4  grid grid-rows-2 grid-cols-1 gap-4 items-center justify-between z-20'>
                        <div className='w-full grid-rows-1 max-h-[20vh] h-full rounded-lg bg-[#F3F3F3] flex-1 relative border border-primary flex items-center justify-center text-primary dark:text-white font-bold'>
                            <h3 className="text-lg">{groupedMatches && groupedMatches['Semi Final'] && groupedMatches['Semi Final'].length > 0 ? groupedMatches['Semi Final'][1].teams.split("X")[0] : null}</h3>
                        </div>
                        <div className='w-full max-h-[20vh] grid-rows-1 h-full rounded-lg bg-[#F3F3F3] flex-1 border border-primary flex items-center justify-center text-primary dark:text-white font-bold'>
                            <h3 className="text-lg">{groupedMatches && groupedMatches['Semi Final'] && groupedMatches['Semi Final'].length > 0 ? groupedMatches['Semi Final'][1].teams.split("X")[1] : null}</h3>
                        </div>
                    </div>
                </div>
                */
